// extracted by extract-css-chunks-webpack-plugin
module.exports = {"calculatorInput":"_YX7zo","holder":"_1UCzgZ","inputBox":"N-ACvG","currencyBox":"_1RlNJT","infoBtn":"_3gXc9s","iconWrapper":"_1_S-LN"};